export default function getResource(label, vars = []) {
    const resources = {
        giftCardBalance: 'Solde de carte-cadeau',
        checkYourBalance: 'Check Balance',
        and: '&',
        addToWallet: 'Add to Wallet',
        toCheckCurrentBalance: 'Pour consulter votre solde actuel, saisissez le numéro de la carte composé de 16 chiffres et le NIP.',
        balance: 'Solde',
        cardNumber: 'Numéro de carte',
        pin: 'NIP',
        check: 'Vérifier',
        checkBalance: 'Check Balance',
        giftCardBalanceModalTitle: 'Your Gift Card Balance',
        appleWalletDisclaimer: 'This balance will continue to be available on your physical/eGift card as well as your Apple Wallet Pass.',
        googleWalletDisclaimer: 'This balance will continue to be available on your physical/eGift card as well as your Google Wallet Pass.',
        addTo: 'Add to',
        appleWallet: 'Apple Wallet',
        googleWallet: 'Google Wallet',
        done: 'Done'
    };

    return resources[label];
}
